import React, { useContext, useId } from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import Badge from '@components/ringil3/Badges/Badge';
import { PermissionTypesEnum, ReservationCoordinates } from '@api/ringil-api.v2';
import { isNotNullOrUndefined } from '@utils/utils';
import { translateWorkflowState } from '@utils/utils';
import { resolveStateIcon } from '@utils/reservation';
import useNavigation from '@hooks/useNavigation.tsx';
import { Link } from 'react-router-dom';
import { Tooltip } from 'primereact/tooltip';
import { AuthenticatedUserContext } from '@components/auth/AuthenticatedUser.tsx';

interface ComponentProps {
  linkedReservation?: ReservationCoordinates;
}

const LinkedResBadge: React.FC<ComponentProps> = ({ linkedReservation }) => {
  const { tr } = useTranslationLgs();
  const navigation = useNavigation();
  const { hasPermission } = useContext(AuthenticatedUserContext);
  const tooltipId = `linked-res-state-${useId().replace(/:/g, '')}`;

  const state = linkedReservation?.state;
  const showStateIcon =
    isNotNullOrUndefined(state) && state.name?.toLowerCase() !== 'new' && isNotNullOrUndefined(state.icon);
  const canOpenDetail = hasPermission([PermissionTypesEnum.PERMISSION_TIMESLOT_DETAIL_READ, PermissionTypesEnum.PERMISSION_TIMESLOT_DETAIL_RW]);

  if (isNotNullOrUndefined(linkedReservation) === false) {
    return <></>;
  }

  const badge = (
    <Badge filled={true} value={linkedReservation.applicationId}
           label={tr(`LinkedResBadge.reservation`, `Reservation`)} highlightedValue={canOpenDetail}
           className={showStateIcon ? 'pr-1' : undefined}>
      {showStateIcon && (
        <>
          <Tooltip target={`#${tooltipId}`} position="top" />
          <span id={tooltipId} data-pr-tooltip={translateWorkflowState(state.name, tr)} className={'inline-flex items-center [&>svg]:!mr-0'}>
            {resolveStateIcon(state.icon)}
          </span>
        </>
      )}
    </Badge>
  );

  if (canOpenDetail === false) {
    return <div>{badge}</div>;
  }

  return (
    <div>
      <Link to={navigation.createNavigationLink(navigation.urlFunctions.createReservationDetail(linkedReservation.id))}>
        {badge}
      </Link>
    </div>
  );
};

export default LinkedResBadge;
